
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-chatbot-for-website",
      function () {
        return require("private-next-pages/ai-chatbot-for-website.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-chatbot-for-website"])
      });
    }
  